import { GuideItem, GuideContent } from '../guides';
import koreaTop10BannerEn from '../../assets/banners/korea-top10-2026-en.png';
import koreaTop10BannerJa from '../../assets/banners/korea-top10-2026-ja.png';
import koreaTop10BannerZhCn from '../../assets/banners/korea-top10-2026-zh-cn.png';
import koreaTop10BannerZhTw from '../../assets/banners/korea-top10-2026-zh-tw.png';

export const guide1Item: GuideItem = {
  id: "1",
  title: "2026 Korea's Top 10 Must-Eats",
  titleEn: "2026 Korea's Top 10 Must-Eats",
  titleJa: "2026年版 韓国で絶対に食べたいグルメTOP10",
  titleZhCn: "2026年必吃的韩国美食TOP10",
  titleZhTw: "2026年必吃的韓國美食TOP10",
  image: koreaTop10BannerEn,
  imageEn: koreaTop10BannerEn,
  imageJa: koreaTop10BannerJa,
  imageZhCn: koreaTop10BannerZhCn,
  imageZhTw: koreaTop10BannerZhTw,
  description:
    "Can't decide what to try?\nWe'll bring Korea's best to your door.",
  descriptionEn:
    "Can't decide what to try?\nWe'll bring Korea's best to your door.",
  descriptionJa: "何を食べるか迷ったらこれ！\n韓国の人気グルメをお届けします。",
  descriptionZhCn: "不知道该吃什么？\n我们把韩国最受欢迎的美味送到你面前!",
  descriptionZhTw: "不知道該吃什麼嗎？\n我們將韓國最受歡迎的美味送到你面前！",
};

export const guide1Content: GuideContent = {
  title: "2026 Korea's Top 10 Must-Eats",
  titleEn: "2026 Korea's Top 10 Must-Eats",
  titleJa: "2026年版 韓国で絶対に食べたいグルメTOP10",
  titleZhCn: "2026年必吃的韩国美食TOP10",
  titleZhTw: "2026年必吃的韓國美食TOP10",
  subtitle:
    "Discover the essential Korean dishes that define the country's culinary heritage",
  subtitleEn:
    "Discover the essential Korean dishes that define the country's culinary heritage",
  subtitleJa: "何を食べるか迷ったらこれ！韓国の人気グルメをお届けします。",
  subtitleZhCn: "不知道该吃什么？我们把韩国最受欢迎的美味送到你面前!",
  subtitleZhTw: "不知道該吃什麼嗎？我們將韓國最受歡迎的美味送到你面前！",
  markdownContent: `
![한국음식-TOP1.png](${koreaTop10BannerEn})

## **Top 10 Must-Try Korean Foods You Shouldn't Miss**

— Experience the Taste of Korea, Delivered Right to You —

Whether it's your first time in Korea or you're back for another visit, Korean food is an essential part of the journey.

From sizzling BBQ to iconic street snacks, Korea offers bold, comforting, and unforgettable flavors.

The best part? You can enjoy all of these must-try dishes **without leaving your hotel or guesthouse** — just a few taps and it's delivered to your door.

## 1. 🥓 **Samgyeopsal (Grilled Pork Belly)**

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+2.png)

# (버튼 1)

Juicy, thick slices of pork belly grilled until golden brown on the outside and tender inside.
Unlike thin bacon, samgyeopsal is sliced thicker, letting you enjoy the full bite of savory pork fat and lean meat together. It's often wrapped in lettuce with garlic and sauces, creating a fresh and rich flavor balance.

**Why it's loved**: It's a classic Korean BBQ dish enjoyed across generations — flavorful, filling, and customizable with every bite.

---

## 2. 🍚 Bibimbap (Mixed Rice Bowl)

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+3.png)

# (버튼 2)

A vibrant bowl of steamed rice topped with vegetables, marinated beef, a fried egg, and spicy gochujang.
Each ingredient is seasoned separately and arranged beautifully before mixing. The mix of textures — crunchy veggies, warm rice, soft egg — makes every spoonful balanced and satisfying.

**Why it's loved**: It's healthy, comforting, and endlessly customizable — a perfect introduction to Korean flavors.

---

## 3. 🍗 Fried Chicken

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+4.png)

# (버튼 3)

Korean fried chicken is known for its ultra-crispy skin and juicy interior, fried twice for extra crunch.
The plain (original) or soy-garlic version is mild but flavorful, often enjoyed with pickled radish and beer — a combo Koreans call "chimaek."

**Why it's loved**: It's global comfort food, elevated with Korean crunch and seasoning.

---

## 4. 🌶️ Tteokbokki (Spicy Rice Cakes)

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+5.png)

# (버튼 4)

Soft, chewy rice cakes simmered in a sweet and spicy red pepper sauce.
It's often mixed with fish cakes, boiled eggs, or fried snacks — creating a bold, saucy street food experience.

**Why it's loved**: It's spicy, addictive, and a taste of everyday Korean snack culture.

---

## 5. 🥩 Bulgogi (Marinated Beef BBQ)

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+6.png)

# (버튼 5)

Thin slices of beef marinated in a sweet soy-based sauce with garlic, onion, and pear juice.
Grilled quickly to retain tenderness, the beef is juicy and slightly sweet — perfect with rice and side dishes.

**Why it's loved**: It's one of Korea's most accessible and mild-flavored dishes, ideal for BBQ first-timers.

---

## 6. 🍱 Gimbap (Korean Rice Rolls)

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+7.png)

# (버튼 6)

Steamed rice and assorted ingredients such as egg, crab stick, tuna, or beef rolled in seaweed.
Each roll is compact, flavorful, and easy to eat — similar in appearance to sushi, but with fully cooked fillings.

**Why it's loved**: It's convenient, light, and perfect for a quick meal or picnic.

---

## 7. 🍜 Jjajangmyeon (Black Bean Noodles)

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+8.png)

# (버튼 7)

Thick noodles drenched in a rich black bean sauce with diced pork and vegetables.
The sauce is savory, slightly sweet, and deeply satisfying — it's a beloved comfort dish in Korean-Chinese cuisine.

**Why it's loved**: It looks bold but tastes mellow — a favorite for both kids and adults.

---

## 8. 🧊 Naengmyeon (Cold Buckwheat Noodles)

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+9.png)

# (버튼 8)

Chilled buckwheat noodles served in an icy, tangy broth or mixed with spicy sauce.
Its chewy texture and refreshing taste make it especially popular during summer.

**Why it's loved**: It's unique, cooling, and surprisingly addictive once you get a taste.

---

## 9. 🌶️ Sundubu Jjigae (Soft Tofu Stew)

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+10.png)

# (버튼 9)

A bubbling hot stew made with uncurdled tofu, vegetables, and your choice of seafood or meat.
The silky tofu soaks up the spicy broth, creating a soothing yet fiery spoonful every time.

**Why it's loved**: It's a cozy dish with depth — soft, spicy, and comforting.

---

## 10. 🌭 Hot Dog (Korean-Style Corn Dog)

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+11.png)

# (버튼 10)

Korean corn dogs are coated in batter and deep-fried — often filled with cheese, sausage, or both.
Some are rolled in sugar, French fries, or ramen bits for a fun twist.

**Why it's loved**: It's playful, crispy, and totally Instagrammable — a favorite street snack!
`,
  markdownContentJa: `
![한국음식-TOP1.png](${koreaTop10BannerJa})

## 絶対に食べたい！韓国の人気グルメTOP10

— ホテルでも楽しめる、本場の韓国の味 —

韓国に初めて訪れる方も、リピーターの方も、韓国料理は旅の楽しみのひとつ。

ジューシーな焼肉から定番の屋台グルメまで、韓国には力強くてどこかホッとする、忘れられない味がたくさんあります。

しかも嬉しいことに、これらの人気メニューはすべて**ホテルやゲストハウスで気軽にデリバリー可能**！

アプリで数回タップするだけで、本場の味があなたのもとへ届きます。



## 1. 🥓 サムギョプサル（豚バラ焼き肉）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+2.png)

# (버튼 1)

外はこんがり、中はジューシーに焼き上げた厚切りの豚バラ肉。

薄いベーコンとは違い、しっかりとした厚みで脂と赤身の旨みをしっかり味わえます。

サンチュにんにくや特製ソースと一緒に包んで食べるスタイルで、さっぱりしつつもコクのある味わいが魅力です。

**人気の理由：**
世代を超えて親しまれている定番の韓国焼肉メニュー。
ボリューム満点で、食べ方のアレンジも自由自在な楽しみ方が魅力です。

---

## 2. 🍚 ビビンバ（混ぜご飯ボウル)

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+3.png)

# (버튼 2)

色とりどりの野菜、味付け牛肉、目玉焼き、そしてコチュジャンがのったご飯ボウル。

具材はそれぞれ丁寧に味付けされ、美しく盛り付けられた後に全体をよく混ぜて食べます。

シャキシャキ野菜、あたたかいご飯、とろりとした卵の食感が絶妙に絡み合い、一口ごとに満足感たっぷり。

**人気の理由：**
ヘルシーでやさしい味わい。自分好みにアレンジもできるので、韓国料理初心者にもぴったりの一品です。

---

## 3. 🍗 フライドチキン（韓国式チキン）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+4.png)

# (버튼 3)

韓国のフライドチキンは、外はカリッと、中はジューシーな食感が特徴。

二度揚げすることで、驚くほどサクサクの衣に仕上げられています。

プレーン（オリジナル）や甘辛い醤油ガーリック味は辛くなく、ピクルスと一緒に、あるいはビールとセットで楽しむ「チメク（チキン＋メクチュ＝ビール）」スタイルが人気です。

**人気の理由：**
世界中で親しまれているコンフォートフードに、韓国ならではの食感と味付けがプラスされた特別な一品です。

---

## 4. 🌶️ トッポッキ（辛口韓国餅の甘辛煮）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+5.png)

# (버튼 4)

モチモチとした食感の韓国餅（トッ）を、甘辛いコチュジャンベースのソースでじっくり煮込んだ一品。

さつま揚げやゆで卵、天ぷらなどを加えることも多く、ソースたっぷりの屋台グルメとして親しまれています。

**人気の理由：**
ピリ辛でクセになる味わい。韓国の日常を感じられる定番スナックです。

---

## 5. 🥩 プルコギ（味付け牛焼き肉）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+6.png)

# (버튼 5)

薄切りの牛肉を、醤油ベースの甘いタレににんにく・玉ねぎ・梨の果汁と一緒に漬け込み、香ばしく焼き上げた韓国定番の肉料理。

短時間で焼くことでやわらかさを保ち、ジューシーでほんのり甘い味わいがご飯や副菜との相性抜群です。

**人気の理由：**
韓国バーベキューの中でも特に食べやすく、辛くないので初心者にもおすすめの一品です。

---

## 6. 🍱 キンパ（韓国風のり巻き）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+7.png)

# (버튼 6)

ご飯と卵、カニカマ、ツナ、牛肉などの具材をのりで巻いた、韓国の定番ロールフード。

見た目はお寿司に似ていますが、中身はすべて火が通っており、味付けも韓国風。

一口サイズで食べやすく、風味豊かで手軽に楽しめます。

**人気の理由：**
軽くて食べやすく、忙しいときの食事やピクニックにもぴったりの便利な一品です。

---

## 7. 🍜 チャジャンミョン（韓国式ジャージャー麺）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+8.png)

# (버튼 7)

もちもちの太麺に、豚肉と野菜が入った濃厚な黒豆ソースをたっぷりとかけた韓国風中華麺。
見た目はインパクトがありますが、味はまろやかでコクがあり、ほんのり甘みも感じられる優しい味わいです。

**人気の理由：**
見た目は濃そうでも、実は食べやすくてクセになる味。子どもから大人まで幅広く愛されている定番メニューです。

---

## 8. 🧊 冷麺（ネンミョン）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+9.png)

# (버튼 8)

冷たいスープにそば粉入りのコシのある麺を入れた、韓国ならではの涼感あふれる一品。
さっぱりとした酸味のあるスープ、またはピリ辛のタレと混ぜて食べるスタイルがあり、暑い季節にぴったりの味わいです。

**人気の理由：**
一度食べるとクセになる独特の食感と爽やかさ。夏の定番メニューとして愛されています。

---

## 9. 🌶️ スンドゥブチゲ（やわらか豆腐の辛口鍋）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+10.png)

# (버튼 9)

ふわふわの純豆腐に野菜、そしてシーフードやお肉を加えて煮込んだ、アツアツの韓国鍋料理。
ピリ辛のスープを豆腐がしっかり吸い込み、とろけるような食感と深みのある味わいが楽しめます。

**人気の理由：**
やわらかくて辛い、でもどこかホッとする。寒い日や疲れたときに食べたくなる、心温まる一品です。

---

## 10. 🌭 韓国式ホットドッグ（コーンドッグ）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+11.png)

# (버튼 10)

チーズやソーセージが入った具を衣で包み、カラッと揚げた韓国式ホットドッグ。

砂糖をまぶしたものや、フライドポテトやラーメンのかけらをつけたバリエーションもあり、見た目もユニークです。

**人気の理由：**
カリッとした食感とユニークな見た目で写真映え抜群！遊び心のある韓国屋台の定番スナックとして大人気です。
`,
  markdownContentZhCn: `
![한국음식-TOP1.png](${koreaTop10BannerZhCn})

## 定要尝一尝！韩国人气美食TOP10

— 在酒店也能轻松享用的正宗韩式美味 —

无论是第一次来韩国，还是已经多次造访，韩国料理都是旅途中不可错过的一部分。

从多汁的烤肉到经典的街头小吃，韩国拥有丰富而令人难忘的味道，既浓郁又让人安心。

更棒的是，这些人气菜单**都可以轻松配送到酒店或民宿**！

只需在配送平台上轻轻点几下，地道韩食就能送上门，让您在住宿地也能尽情享受正宗风味。

## 1. 🥓 五花肉烤肉（Samgyeopsal）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+2.png)

# (버튼 1)

外焦里嫩的厚切五花肉，在烤盘上滋滋作响。

比培根更厚实，肥瘦相间，一口下去满是肉香。

通常配上生菜、大蒜和酱料一起包着吃，清爽又浓郁的口感让人停不下来。

**受欢迎的原因：**
经典的韩国烧烤代表，世代相传的国民美食，每一口都可以自由搭配，吃法多样。

---

## 2. 🍚 拌饭（Bibimbap）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+3.png)

# (버튼 2)

色彩丰富的米饭上铺满了各式蔬菜、腌制牛肉、煎蛋和辣椒酱。
每种食材都经过单独调味，拌匀后呈现出丰富层次的口感——爽脆的蔬菜、温热的米饭、柔软的蛋，每一口都令人满足。

**受欢迎的原因：**
健康、暖胃又可自由搭配，是体验韩国风味的绝佳入门餐点。

---

## 3. 🍗 炸鸡（Fried Chicken）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+4.png)

# (버튼 3)

韩国炸鸡以酥脆的外皮和多汁的内里著称，采用两次油炸，口感特别香脆。
原味或酱油蒜香口味不辣却十分入味，常搭配腌萝卜和啤酒一起享用，这种组合被称为“치맥”（炸鸡＋啤酒）。

**受欢迎的原因：**
这是一道全球都爱的安慰系美食，加上韩国特有的酥脆与调味，更让人欲罢不能。

---

## 4. 🌶️ 辣炒年糕（Tteokbokki）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+5.png)

# (버튼 4)

柔软有嚼劲的年糕在甜辣的红辣椒酱中慢慢炖煮。
常搭配鱼饼、水煮蛋或油炸小吃，是韩国街头常见的经典小吃。

**受欢迎的原因：**
又辣又上瘾，浓厚酱汁中藏着地道的韩国小吃文化。

---

## 5. 🥩 烤牛肉（Bulgogi）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+6.png)

# (버튼 5)

薄切牛肉用酱油为基础的甜味酱汁，搭配大蒜、洋葱和梨汁腌制入味。
快速烤制，保持柔嫩口感，带着微甜的香气，配白饭和小菜刚刚好。

**受欢迎的原因：**
口味温和不辣，是韩国烧烤中最适合“新手”的一道菜。

---

## 6. 🍱  紫菜包饭（Gimbap）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+7.png)

# (버튼 6)

将米饭和鸡蛋、蟹棒、金枪鱼或牛肉等配料卷入紫菜中，切成方便入口的小块。
外观类似寿司，但里面的食材都是熟的，风味更偏韩式。

**受欢迎的原因：**
轻便好吃，适合当作快速简餐或野餐便当。

---

## 7. 🍜 炸酱面（Jjajangmyeon）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+8.png)

# (버튼 7)

弹的粗面条淋上浓郁的黑豆酱，再加入猪肉丁和蔬菜。
味道咸香中带点微甜，是韩式中餐中非常有人气的安慰系美食。

**受欢迎的原因：**
看起来重口，但吃起来却柔和顺口，大人小孩都爱吃。

---

## 8. 🧊 冷面（Naengmyeon）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+9.png)

# (버튼 8)

冰凉的荞麦面浸在酸爽的冷汤中，或拌上微辣酱汁。
咬劲十足，口感清爽，特别适合炎热的夏天食用。

**受欢迎的原因：**
独特又解暑，一试就会上瘾，是夏季人气之选。

---

## 9. 🌶️ 嫩豆腐汤（Sundubu Jjigae）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+10.png)

# (버튼 9)

用嫩豆腐、蔬菜和海鲜或肉类炖煮而成的红汤锅物，热腾腾上桌。
柔滑的豆腐吸满辛辣的汤汁，辛香中带着温润的暖意。

**受欢迎的原因：**
软、辣、暖，一口下去就让人觉得安心又满足。

---

## 10. 🌭 韩国热狗（Hot Dog / Corn Dog）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+11.png)

# (버튼 10)

裹上面糊油炸的热狗，有些是芝士和香肠组合，也有撒上糖粉、薯条块或方便面碎的创意版本。
外酥里嫩，造型趣味十足。

**受欢迎的原因：**
香脆好吃又好拍，是最受欢迎的街头小吃之一。
`,
  markdownContentZhTw: `
![한국음식-TOP1.png](${koreaTop10BannerZhTw})

## 定要嚐嚐！韓國人氣美食TOP10

— 在飯店也能輕鬆享用的道地韓國味 —

無論您是第一次來韓國旅行，還是已經多次造訪，韓國料理絕對是旅途中不可或缺的樂趣之一。

從多汁的烤肉到經典的街頭小吃，韓國有著既濃郁又療癒、令人難忘的美食風味。

更棒的是，這些人氣餐點**通通都能直接外送到您的飯店或民宿**！

只需在外送平台上輕輕點幾下，道地美味就會直送到您的房門前！

## 1. 🥓 五花肉（Samgyeopsal）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+2.png)

# (버튼 1)

外酥內嫩的厚切豬五花，烤得滋滋作響，香氣四溢。

比培根厚實，肥瘦交錯，每一口都充滿肉香與口感。常搭配生菜、大蒜與韓式醬料一起包著吃，清爽又濃郁。

**為什麼受歡迎：**
韓國經典燒烤代表，老少皆宜，吃法多變，每一口都可以自訂口味。

---

## 2. 🍚  拌飯（Bibimbap）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+3.png)

# (버튼 2)

一碗色彩繽紛的白飯，鋪上各式調味蔬菜、牛肉、煎蛋與辣椒醬。

每種配料都各自調味，拌在一起後口感豐富——脆嫩蔬菜、熱騰騰的飯、滑順蛋黃，每一口都讓人滿足。

**為什麼受歡迎：**
健康又有飽足感，可自由搭配，是入門韓食的絕佳選擇。

---

## 3. 🍗 韓式炸雞（Fried Chicken）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+4.png)

# (버튼 3)

外皮酥脆、內部多汁，使用雙重油炸技術讓口感更升級。

原味與醬油蒜香不辣卻非常入味，搭配醃白蘿蔔與啤酒就是韓國人氣組合「치맥」。

**為什麼受歡迎：**
全球都愛的療癒系美食，加入韓式酥脆與調味後更具魅力。

---

## 4. 🌶️ 辣炒年糕（Tteokbokki）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+5.png)

# (버튼 4)

彈的年糕在甜辣醬中燉煮入味，常搭配魚板、水煮蛋或炸物。

濃郁醬汁加上多元配料，是韓國街頭小吃的代表作。

**為什麼受歡迎：**
香辣開胃，令人上癮，是最具代表性的韓式小吃之一。

---

## 5. 🥩 韓式烤牛肉（Bulgogi）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+6.png)

# (버튼 5)

薄切牛肉以醬油、蒜頭、洋蔥與梨汁醃製後燒烤，肉質鮮嫩、微甜香氣撲鼻。

搭配白飯與小菜，是韓國人從小吃到大的國民美食。

**為什麼受歡迎：**
口感溫和、甜鹹適中，是初次嘗試韓式燒烤的絕佳選擇。

---

## 6. 🍱  紫菜飯捲（Gimbap）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+7.png)

# (버튼 6)

將白飯與蛋、蟹肉棒、鮪魚、牛肉等配料用紫菜捲起來，切成方便入口的小塊。

外觀看似壽司，但使用熟食材料與韓式調味，是便當與輕食的好選擇。

**為什麼受歡迎：**
輕巧方便，適合野餐、外出或快速用餐時享用。

---

## 7. 🍜 炸醬麵（Jjajangmyeon）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+8.png)

# (버튼 7)

彈麵條淋上濃郁黑豆醬，搭配豬肉丁與蔬菜。

口味鹹甜交融，是韓式中華料理中極具人氣的經典麵點。

**為什麼受歡迎：**
雖然外觀看起來重口味，但吃起來香而不膩，大人小孩都喜歡。

---

## 8. 🧊 冷麵（Naengmyeon）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+9.png)

# (버튼 8)

清爽的蕎麥冷麵搭配冰涼湯頭或辣醬，吃起來清涼解暑。

有嚼勁的麵條與微酸風味是夏季最受歡迎的選擇。

**為什麼受歡迎：**
消暑、獨特又上癮，一試就成為粉絲。

---

## 9. 🌶️ 嫩豆腐湯（Sundubu Jjigae）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+10.png)

# (버튼 9)

使用柔滑未凝固的嫩豆腐，加入蔬菜與海鮮或豬肉，燉煮成辛香紅湯鍋。

每一口都充滿豆腐的滑嫩與湯汁的辣香。

**為什麼受歡迎：**
柔軟、辣又溫暖，是令人安心的熱湯料理。

---

## 10. 🌭 韓國熱狗（Hot Dog / Corn Dog）

![](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%83%E1%85%A2%E1%84%8C%E1%85%B5+11.png)

# (버튼 10)

將香腸、起司或兩者結合，裹上麵糊油炸而成。

有些還裹上糖粉、薯條或泡麵碎，創意十足、外型吸睛。

**為什麼受歡迎：**
酥脆好吃又吸睛，是最受觀光客與年輕人喜愛的街頭點心之一。
`,
  inlineButtons: [
    {
      id: "1",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      menuName: "Samgyeopsal",
    },
    {
      id: "2",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      menuName: "Bibimbap",
      categoryId: "JUGm4biv",
    },
    {
      id: "3",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      menuName: "Chicken",
      categoryId: "MViVQSYI",
    },
    {
      id: "4",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      menuName: "Tteokbokki"
    },
    {
      id: "5",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      menuName: "Bulgogi",
      categoryId: "JUGm4biv",
    },
    {
      id: "6",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      menuName: "Gimbap",
    },
    {
      id: "7",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      menuName: "Jjajang",
    },
    {
      id: "8",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      menuName: "Naengmyeon",
    },
    {
      id: "9",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      menuName: "Sundubu Jjigae",
      categoryId: "JUGm4biv",
    },
    {
      id: "10",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      menuName: "Hot Dog",
    }
  ],
}; 